import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'partnersSection',
    components: {
        Carousel,
        Slide
    },
    // created: {
    // },

};
